define([
	"dojo/_base/declare",
	"csi/heading/AttributeAction"
], function(declare,AttributeAction) {

	return declare(AttributeAction, {
		constructor: function(def) {
			this.m_id = "FullSizeImage";
		}
	});
});